import React, {useEffect, useState} from 'react';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Button, Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import AddTranslation from "./AddTranslation";
import {connect} from "react-redux";
import TranslationList from "./List/TranslationList";
import {getTranslation, removeTranslation} from "../../store/translations/actions";

const Translations = ({ translationList, isLoadingAddTranslation, removeTranslation, getTranslation }) => {
  const [onAddNewTranslationsModal, setOnAddNewTranslationsModal] = useState(false)

  const [currentPage] = useState(1)

  useEffect(() => {
    getTranslation({page: currentPage})
  }, [currentPage, getTranslation])

  const onNewTranslationSubmit = () => {
    console.log('submit')
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Преводи на услуги" breadcrumbItem="Преводи на услуги"/>

          <Row>
            <Col>
              <Card>
                {/*<div className="d-inline-flex ant-row-space-between align-items-center">*/}
                {/*  <Paging setPage={setPage} currentPage={currentPage} pages={translationList?.pages}/>*/}
                {/*  <Space direction="horizontal" className="mr-4">*/}
                {/*    <Button type={'button'} className='btn btn-info waves-effect waves-light search-btn'*/}
                {/*            onClick={() => setFilterModalOpen(!filterModalOpen)}><i*/}
                {/*      className="bx bx-filter-alt align-middle"></i></Button>*/}
                {/*    {(search.text || Object.keys(search.tagsFilters).length > 0) &&*/}
                {/*      <Button type={'button'} className='btn btn-dark waves-effect waves-light search-btn'*/}
                {/*              onClick={refreshPage}><i*/}
                {/*        className='bx bx-revision align-middle'></i></Button>}*/}
                {/*  </Space>*/}
                {/*</div>*/}
                <CardHeader>
                  <Button
                    color="success"
                    className="btn btn-success waves-effect waves-light"
                    onClick={() => setOnAddNewTranslationsModal(!onAddNewTranslationsModal)}
                  >
                    {" "}
                    <i className=""> </i> Добави превод на услуга
                  </Button>
                </CardHeader>
                <CardBody>
                  {translationList && translationList?.translations && <TranslationList
                    lists={translationList?.translations}
                    disableService={(e)=> removeTranslation(e)}
                  />}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <AddTranslation
        isLoading={isLoadingAddTranslation}
        isNewTranslationModalOpen={onAddNewTranslationsModal}
        onSubmit={onNewTranslationSubmit}
        onCancel={() => setOnAddNewTranslationsModal(false)}
      />
      {/*<Search searchModalOpen={filterModalOpen}*/}
      {/*        options={options}*/}
      {/*        filterData={['createdAt']}*/}
      {/*        searchVar={search}*/}
      {/*        tags={translationList?.translations}*/}
      {/*        onSubmit={onSubmit}*/}
      {/*        onCancel={() => setFilterModalOpen(false)}/>*/}
    </React.Fragment>
  );
}
const mapStateToProps = ({Translations}) => {

  return Translations
}

export default connect(mapStateToProps, {getTranslation, removeTranslation})(Translations);
